// extracted by mini-css-extract-plugin
export default {"page":"Checkout_page__ETsa3","card__head":"Checkout_card__head__w83id","card__title":"Checkout_card__title__lHP6w","creditcard__input":"Checkout_creditcard__input__yLyBk"};